import React from 'react';

const CardMenuIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size}  
      viewBox="0 0 36 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect 
        x="1" 
        y="1" 
        width="34" 
        height="24" 
        rx="5" 
        stroke={color} 
        strokeWidth="2"
      />
      <path 
        d="M14.6 19H7.8M11.2 14.3846H7.8M1 8H35" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M24 17C24 15.5855 24 14.879 24.4395 14.4395C24.879 14 25.5855 14 27 14C28.4145 14 29.121 14 29.5605 14.4395C30 14.879 30 15.5855 30 17C30 18.4145 30 19.121 29.5605 19.5605C29.121 20 28.4145 20 27 20C25.5855 20 24.879 20 24.4395 19.5605C24 19.121 24 18.4145 24 17Z" 
        stroke={color} 
        strokeWidth="2"
      />
    </svg>
  );
};

export default CardMenuIcon;
